import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Spin} from 'kpc';

var _$tmp0 = {
    'color': '#f0b'
};
var _$tmp1 = {
    'color': '#0fb',
    'strokeWidth': 16
};
var _$tmp2 = {
    'size': 64
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Spin, _$tmp0),
        _$cc(Spin, _$tmp1),
        _$cc(Spin, _$tmp2)
    ], 4);
};